import type { ResellerTld, SetRetailPricesRequest } from "@kilat/contracts/reseller-pricing";
import { useMutation } from "@tanstack/react-query";
import { setRetailPrices } from "../api";
import { pricingKeys } from "../queries";

// The answer is the TLD as the list shows it: it replaces that row in the cached list.
export const useSetRetailPrices = (tldId: string) =>
  useMutation({
    mutationFn: (prices: SetRetailPricesRequest) => setRetailPrices(tldId, prices),
    onSuccess: ({ data }, _prices, _result, { client }) => {
      client.setQueryData(pricingKeys.tlds(), (list: ResellerTld[] | undefined) =>
        list?.map((tld) => (tld.id === data.id ? data : tld)),
      );
    },
  });
